import { SET_FILTER } from './lybunt.action';

import { lybuntInitialState } from 'src/redux/lybunt/lybunt.initialState';

export const lybuntReducer = (state = lybuntInitialState, action) => {
	switch (action.type) {
		case SET_FILTER: {
			return {
				filter: {
					...state.filter,
					[action.payload.filterName]: action.payload.filters
						? action.payload.filters
						: action.payload,
				},
			};
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/lybunt/lybunt.reducer.js